import lazyWithRetry from "../../../../../utils/lazyWithRetry";
const AllDrivers = lazyWithRetry(() => import("./AllDrivers/AllDrivers"));
const Bags = lazyWithRetry(() => import("./Bags/Bags"));
const AddBag = lazyWithRetry(() => import("./AddBag/AddBag"));
const BagSales = lazyWithRetry(() => import("./BagSales/BagSales"));
const BagHistory = lazyWithRetry(() => import("./BagHistory/BagHistory"));
const BagReconciliation = lazyWithRetry(() => import("./BagReconciliation/BagReconciliation"));
const BagAssignmentDetail = lazyWithRetry(() => import("./BagAssignmentDetail/BagAssignmentDetail"));

const BagsHistory = lazyWithRetry(() => import("./BagsHistory/BagsHistory"));
const PendingBagTransfers = lazyWithRetry(() => import("./PendingBagTransfers/PendingBagTransfers"));
const CashHandovers = lazyWithRetry(() => import("./CashHandovers/CashHandovers"));
const CashHandoverDriver = lazyWithRetry(() => import("./CashHandovers/CashHandoverDriver"));

export { AllDrivers, Bags, AddBag, BagSales, BagHistory, BagReconciliation, BagAssignmentDetail, BagsHistory, PendingBagTransfers, CashHandovers, CashHandoverDriver };
